import Vue from 'vue';

const indexState = (() => {
  let indexCategoriesFilters = [];
  let indexGroupsFilters = [];

  if (typeof localStorage !== "undefined") {
    let rawCategories = localStorage.getItem('categories');
    if (rawCategories) indexCategoriesFilters = JSON.parse(rawCategories) || [];
    let rawGroups = localStorage.getItem('groups');
    if (rawGroups) indexGroupsFilters = JSON.parse(rawGroups);
  }

  return {
    indexGroupsFilters,
    indexCategoriesFilters,
  };
})();

const indexActions = {
  setIndexCategoriesFilters({ commit }, indexCategoriesFilters) {
    commit('setIndexCategoriesFilters', indexCategoriesFilters);
    localStorage.setItem('categories', JSON.stringify(indexCategoriesFilters));
  },
  async watchTotalCount(store) {
    const database = this._vm.firebase.database();
    const currentUserId = await store.dispatch("loggedInUserId");
    const ref = database.ref().child('chat').child(currentUserId).orderByChild("unreadCount");
    ref.on("value", (snap) => {
      const children = snap.val() || [];
      for (let chatId in children) {
        const count = children[chatId].unreadCount;
        store.commit('setChatUnreadCounts', { chatId, count });
      }
    });
  },
};

const indexGetters = {
  isFilterOn: (state) => {
    let filter = [...state.indexGroupsFilters, ...state.indexCategoriesFilters];
    return filter.length > 0;
  },
  conversationsState: (state) => {
    if (Object.keys(state.conversationIds).length) {
      return 'loaded';
    } else {
      return 'empty';
    }
  },
  conversations: (state) => {
    const Indexs = [];
    for (const id in state.conversationIds) {
      chats.push(id);
    }
    return chats;
  },
  getMyMessages: (state) => {
    let lastDate = "";
    let messageDate = "";
    const messages = [];
    for (let id in state.myMessages) {
      const message = state.myMessages[id];
      messageDate = getDateFromTimestamp(message.timestamp);
      if (messageDate !== lastDate) {
        lastDate = messageDate;
      }
      messages.push(message);
    }

    return messages;
  },
};

const indexMutations = {
  setIndexCategoriesFilters(state, indexCategoriesFilters) {
    state.indexCategoriesFilters = indexCategoriesFilters;
  },
  setConversationIds(state, conversationIds) {
    Vue.set(state, 'conversationIds', conversationIds);
  },
};

export {
  indexState,
  indexActions,
  indexGetters,
  indexMutations
};
// 136
